import { useEffect, useState } from 'react';
import { isMobile } from 'react-device-detect';

const useFrameSize = (containerRef: React.RefObject<HTMLDivElement>, aspect = 2) => {
  const [size, setSize] = useState<{ width: number; height: number; full?: boolean }>();

  useEffect(() => {
    if (containerRef.current) {
      const container = containerRef.current;
      const update = () => setSize(computeSize(container, aspect));

      update();
      window.addEventListener('resize', update);

      return () => window.removeEventListener('resize', update);
    }
  }, [aspect, containerRef]);

  return size;
};

export default useFrameSize;

const computeSize = (container: HTMLDivElement, aspect: number) => {
  const cw = container.offsetWidth;
  const ch = container.offsetHeight;

  if (cw < ch * 0.7 || isMobile) {
    return { width: cw, height: ch, full: true };
  }

  let w = cw;
  let h = w * aspect;

  if (h > ch * 0.9) {
    h = ch;
    w = h / aspect;
  }

  return { width: w * 0.9, height: h * 0.9 };
};
